import React, { Component } from 'react';
import { connect } from 'react-redux';
import i18n from 'react-intl-universal';
import { withRouter, Link } from 'react-router-dom';
import classNames from 'classnames';
import styles from './HistoryListContainer.scss';
import { NoteHistory } from '../../constants/actionTypes';
import NestLoading from '../../components/Loading/NestLoading';
import { getNoteHistoryState } from '../../reducers/NoteHistory/NoteHistoryReducer';
import Icon from '../../components/Icon/Icon';
import { getNoteHistoryList } from '../../actions/NoteHistoryAction';
import timeago from '../../utils/timeago';
import formatDate from '../../utils/formatDate';

@withRouter
@connect(
  state => ({
    noteHistory: getNoteHistoryState(state),
  }),
  dispatch => ({
    getNoteHistoryList: noteId => dispatch(getNoteHistoryList(noteId)),
  }),
)
export default class HistoryListContainer extends Component {
  state = {
    showFilterList: false,
    filterItems: [
      {
        text: i18n.get('history.auto-save'),
        logType: 1,
        checked: true,
      },
      {
        text: i18n.get('history.publicize'),
        logType: 2,
        checked: true,
      },
      {
        text: i18n.get('history.update'),
        logType: 3,
        checked: true,
      },
      {
        text: i18n.get('history.recovery'),
        logType: 4,
        checked: true,
      },
      {
        text: i18n.get('history.web'),
        app: 4, // app来源
        checked: true,
      },
      {
        text: i18n.get('history.ios'),
        app: 1,
        checked: true,
      },
      {
        text: i18n.get('history.android'),
        app: 2,
        checked: true,
      },
      {
        text: i18n.get('history.ios-night'),
        app: 3,
        checked: true,
      },
    ],
  };

  componentWillMount() {
    const { match, history } = this.props;
    const { params: { nbId, noteId } } = match;
    this.props.getNoteHistoryList(noteId);
  }

  // eslint-disable-next-line class-methods-use-this
  componentWillReceiveProps(nextProps) {
    const { match, history, noteHistory } = nextProps;
    const { params: { nbId, noteId, historyId } } = match;
    const noteHistoryList = noteHistory.get('list');
    // 首次进来有可能存在没有historyId的情况
    if (!historyId && noteHistoryList.size > 0) {
      const hid = noteHistoryList.first().get('id');
      history.replace(`/notebooks/${nbId}/notes/${noteId}/history/${hid}`);
    }
  }

  onFilterItemChange = (index, e) => {
    const data = this.state.filterItems[index];
    data.checked = !data.checked;
    this.setState({
      filterItems: this.state.filterItems,
    });
  };

  renderFilterItems = () => {
    const { filterItems } = this.state;
    return (
      filterItems.map((v, k) => {
        return (
          <label className="checkbox" key={k}>
            <input
              type="checkbox"
              checked={v.checked}
              data-note-log-type={v.logType}
              onChange={e => this.onFilterItemChange(k, e)}
            />
            {v.text}
          </label>
        );
      })
    );
  };

  onHistoryItemClick = (e, historyId) => {
  };
  // 获取filterItems中的text字段，用于显示listitem
  getDisplayName = (prop, v) => {
    const { filterItems } = this.state;
    const textObj = filterItems.filter(fitem => fitem[prop] === v) || [{}];
    return textObj[0].text || '';
  }
  noteListItemOnMouseMove = (e) => {
    const spanElem = e.currentTarget.querySelector('span');
    spanElem.innerHTML = spanElem.getAttribute('data-title');
  };

  noteListItemOnMouseLeave = (e) => {
    const spanElem = e.currentTarget.querySelector('span');
    spanElem.innerHTML = spanElem.getAttribute('data-timeago');
  };
  renderHistoryItems = (items) => {
    const { noteHistory, match } = this.props;
    const { params: { nbId, noteId, historyId } } = match;
    return items.map((v, k) => {
      const itemClasses = classNames({
        [styles['active']]: +historyId === v.id,
      });
      const timeAgo = timeago(v.updated_at * 1000, i18n.get('history.timeago'));
      return (
        <li
          key={k}
          className={itemClasses}
          onMouseMove={this.noteListItemOnMouseMove}
          onMouseLeave={this.noteListItemOnMouseLeave}
        >
          <Link to={`/notebooks/${nbId}/notes/${noteId}/history/${v.id}`}>
            <span
              data-title={formatDate(new Date(v.updated_at * 1000), 'yyyy-MM-dd hh:mm')}
              data-formatted-created-at={v.updated_at}
              data-timeago={timeAgo}
            >
              {timeAgo}
            </span>
            {this.getDisplayName('logType', v.note_log_type)}
          </Link>
        </li>
      );
    });
  };

  toggleFilterList = () => {
    this.setState({
      showFilterList: !this.state.showFilterList,
    });
  };

  // eslint-disable-next-line class-methods-use-this
  render() {
    const { noteHistory } = this.props;
    const { showFilterList, filterItems } = this.state;
    const filterListClasses = classNames(styles['filter-factors-list'], {
      [styles['filter-factors-list__active']]: showFilterList,
    });
    const noteHistoryStatus = noteHistory.get('status');
    const loading = noteHistoryStatus === NoteHistory.GET_NOTE_HISTORY_LIST; // 正在获取则显示loading

    // 选中的过滤条件
    const logTypeCheckedItems = filterItems
      .filter(v => v.checked)
      .map(v => v.logType)
      .filter(v => v);
    const appFromCheckedItems = filterItems
      .filter(v => v.checked)
      .map(v => v.app)
      .filter(v => v);
    // 对noteHistory过滤
    const historyItems = noteHistory.get('list').toJS()
      .filter(v => logTypeCheckedItems.indexOf(v.note_log_type) > -1)
      .filter(v => appFromCheckedItems.indexOf(v.app) > -1);
    return (
      <div className={styles['history-list-wrap']}>
        <div className={styles['filter-wrap']}>
          <div className={styles['filer-title']}>
            <Icon name='history' className={styles['icon-clock-o']}/>
            {i18n.get('history.total-items', { num: historyItems.length })}
            <span className={styles['filter-contol-btn']} onClick={this.toggleFilterList}>
              {i18n.get('history.filter')}
              <Icon name='angle-double-down' className={styles['icon-clock-o']}/>
            </span>
          </div>
          <div className={filterListClasses}>
            {this.renderFilterItems()}
          </div>
        </div>
        <ul className={styles['history-list']}>
          {this.renderHistoryItems(historyItems)}
          <NestLoading
            loading={loading}
          />
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/HistoryListContainer/HistoryListContainer.js